// Parent-change history for the Diagnostics move map.

const normSerial = (v) => String(v || '').toLowerCase().replace(/:/g, '').trim();

export const PARENT_MOVE_LIMITS = [5, 10, 20];
export const DEFAULT_PARENT_MOVE_LIMIT = 10;

// The last `limit` parent changes, oldest first and numbered from 1.
export function parentMoves(events, limit = DEFAULT_PARENT_MOVE_LIMIT) {
  const moves = (events || [])
    .filter((ev) => ev.type === 'parent_change' && ev.from_value && ev.to_value)
    .map((ev) => ({ at: ev.event_at, from: normSerial(ev.from_value), to: normSerial(ev.to_value), event: ev }))
    .sort((a, b) => new Date(a.at) - new Date(b.at));
  return moves.slice(-limit).map((m, i) => ({ ...m, n: i + 1 }));
}

// Every serial a set of moves touches, in first-seen order.
export function moveSerials(moves) {
  const out = [];
  const seen = new Set();
  (moves || []).forEach(({ from, to }) => {
    [from, to].forEach((s) => {
      if (!seen.has(s)) {
        seen.add(s);
        out.push(s);
      }
    });
  });
  return out;
}

// Bend for each move: repeats of the same directed hop bow out further, and
// the reverse hop bows to the other side because its direction flips.
export function moveBends(moves) {
  const repeats = new Map();
  return (moves || []).map(({ from, to }) => {
    const key = `${from}>${to}`;
    const i = repeats.get(key) || 0;
    repeats.set(key, i + 1);
    return 0.18 + 0.12 * i;
  });
}

// Quadratic curve from a to b, bowed to the left of the direction of travel
// by bend times the hop length. Returns points and the curve midpoint.
export function curvedPath(a, b, bend, steps = 24) {
  const dLat = b.lat - a.lat;
  const dLng = b.lng - a.lng;
  const ctrl = {
    lat: (a.lat + b.lat) / 2 + dLng * bend,
    lng: (a.lng + b.lng) / 2 - dLat * bend,
  };
  const at = (t) => {
    const u = 1 - t;
    return {
      lat: u * u * a.lat + 2 * u * t * ctrl.lat + t * t * b.lat,
      lng: u * u * a.lng + 2 * u * t * ctrl.lng + t * t * b.lng,
    };
  };
  const points = [];
  for (let i = 0; i <= steps; i += 1) points.push(at(i / steps));
  return { points, mid: at(0.5) };
}
